import { ToastrService } from 'ngx-toastr';
import { Component, OnInit } from '@angular/core';
import { RoleService } from 'src/app/service/auth/role.service';
import { UserRoleService } from 'src/app/service/auth/user-role.service';

@Component({
    selector: 'app-user-role',
    templateUrl: './user-role.component.html',
    styles: []
})
export class UserRoleComponent implements OnInit {
    constructor(
        private userRoleService: UserRoleService,
        private roleService: RoleService,
        private toastr: ToastrService
    ) { }

    roles: any[] = [];
    userRoles: any[] = [];

    ngOnInit() {
        this.loadDataRole();
        this.loadDataUserRole();
    }

    loadDataRole() {
        this.roleService.getListRole().subscribe(
            res => {
                this.roles = <any>res;
            },
            err => {
                this.toastr.error(err.error ? err.error.message : JSON.stringify(err), 'Lỗi.');
            },
        );
    }

    loadDataUserRole() {
        this.userRoleService.getListUserRole().subscribe(
            res => {
                this.userRoles = <any>res;
            },
            err => {
                this.toastr.error(err.error ? err.error.message : JSON.stringify(err), 'Lỗi.');
            },
        );
    }

    onRefresh() {
        this.loadDataUserRole();
    }

    onSave() {
        document.getElementById('page-loader-data').style.display = "block";
        
        if (this.userRoles.find(x => !x.roleId)) {
            this.toastr.error("Vai trò không được để trống", 'Lỗi.');
            document.getElementById('page-loader-data').style.display = "none";
            return;
        }

        for (const item of this.userRoles) {
            item.roleName = this.roles.find(x => x.id == item.roleId).name;
        }
        this.userRoleService.updateUserRole(this.userRoles).subscribe(
            res => {
                this.toastr.success("Thành công");
                this.loadDataUserRole();
                document.getElementById('page-loader-data').style.display = "none";
            },
            err => {
                this.toastr.error(err.error ? err.error.message : JSON.stringify(err), 'Lỗi.');
                document.getElementById('page-loader-data').style.display = "none";
            },
        );
    }
}